'use strict';

angular
    .module('app')
    .filter('comma2dot', function () {
        return function (value) {
            return String(value).replace(',', '.');
        };
    });
